import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import SocialContributionCard from "visual-components/analytics/campaign/social-contribution-card";

class SocialContribution extends Component {
  render() {
    const { data, started } = this.props;

    return <SocialContributionCard data={data} started={started} />;
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.analyticsCampaign.campaignSocialContributionByBrand.data,
  };
};

export default connect(mapStateToProps)(SocialContribution);
